// local
// const BASE_URL = `http://192.168.7.19:5001/node-api/`
// const DEFAULT_KEY = 'e136fb78-ee9c-4591-9f37-db3346821abc'
// const PAYPAL_CLIENT_ID = "ATtY3CotjXVye4iosAlVI4cuihnv8nNg_Y8R-dRLWPe_-GawRjLbtKqZxlSfP6XDOJlbvMR0I4ziL0a_"

// demo
// const BASE_URL = "https://admin.ubimiracle.iossmlm.com/node-api/"
// const DEFAULT_KEY = 'e136fb78-ee9c-4591-9f37-db3346821abc'
// const PAYPAL_CLIENT_ID = "ATtY3CotjXVye4iosAlVI4cuihnv8nNg_Y8R-dRLWPe_-GawRjLbtKqZxlSfP6XDOJlbvMR0I4ziL0a_"

// LIVE
const BASE_URL = "https://admin.ubimiracleglobal.com/node-api/" 
const DEFAULT_KEY = 'e136fb78-ee9c-4591-9f37-db3346821abc'
const PAYPAL_CLIENT_ID = ""

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID }
